var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('envelope', {
    attrs: {
      "preview": "",
      "skin": _vm.order.skin,
      "aspect-ratio": 5 / 7
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var _vm$order$event;
        var w = _ref.w;
        return [_vm.order.design_id == _vm.nullCoverDesignId ? _c('div', {
          staticClass: "overflow-visible d-flex align-center",
          staticStyle: {
            "aspect-ratio": "5 / 7"
          }
        }, [_c('v-card', {
          staticClass: "fill-width",
          attrs: {
            "tile": "",
            "dark": ""
          }
        }, [_c('v-img', {
          attrs: {
            "aspect-ratio": 16 / 9,
            "src": _vm.groupVideoBlob.group_video.poster
          }
        })], 1)], 1) : _c('v-card', {
          staticClass: "overflow-hidden",
          attrs: {
            "tile": ""
          }
        }, [_c('card-preview', {
          attrs: {
            "mode": _vm.mode || 'edit',
            "card": _vm.order,
            "width": w,
            "is-card-owner": true
          }
        })], 1), _vm.order.type == 'INVITATION' ? _c('div', {
          staticClass: "absolute",
          staticStyle: {
            "width": "120%",
            "height": "120%",
            "bottom": "-5%",
            "right": "0",
            "transform": "rotate(5deg) scale(.5)",
            "transform-origin": "bottom right"
          }
        }, [_c('v-card', {
          staticClass: "absolute-fill overflow-hidden px-4",
          attrs: {
            "tile": "",
            "elevation": "20"
          }
        }, [_c('div', {
          staticClass: "py-3 title text-center"
        }, [_vm._v("RSVP")]), _c('v-divider', {
          staticClass: "mb-n3"
        }), (_vm$order$event = _vm.order.event) !== null && _vm$order$event !== void 0 && _vm$order$event.form ? _c('form-rsvp', {
          staticStyle: {
            "user-select": "none",
            "pointer-events": "none"
          },
          attrs: {
            "form": _vm.order.event.form,
            "response": {},
            "disabled": true
          }
        }) : _vm._e()], 1)], 1) : _vm._e()];
      }
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }